<template>
  <div class="content-area" :style="contentCss">
    <vs-navbar
      class="navbar-custom navbar-skelton"
      :color="''"
      type="fund"
      text-color="#FFFFFF"
      active-text-color="#FFCC00"
    >
      <div tag="div" class="vx-logo cursor-pointer mr-auto flex items-center">
        <img
          :src="appSettings.logo.full_path"
          alt="logo"
          class="logo-img mr-4"
          v-if="appSettings.logo"
        />
        <span class="mr-4" :style="navBarVLogoText">Agent Academy</span>
      </div>

      <vs-navbar-item index="0">
        <vs-dropdown
          vs-custom-content
          vs-trigger-click
          class="profil_dropdown cursor-pointer"
        >
          <span class="text-dark font-bold">{{ user_displayName }}</span
          ><feather-icon
            icon="ChevronDownIcon"
            svgClasses="text-black stroke-current w-4 h-8"
          />
          <vs-dropdown-menu>
            <ul style="min-width: 9rem">
              <li
                @click="logout()"
                class="
                  flex
                  py-2
                  px-4
                  cursor-pointer
                  hover:bg-primary hover:text-white
                "
              >
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                <span class="ml-2">Déconnexion</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>
      </vs-navbar-item>
    </vs-navbar>

    <div class="information-section">
      <div class="column actions">
        <p class="welcome_title font-bold">Pack Débutant</p>
        <p class="welcome_message mt-4">
          <span class="yello">Y’ello </span>
          <span class="user_displayname font-bold">{{ user_displayName }}</span
          >, bienvenue sur Agent Academy. Avant d’accéder au catalogue des
          formations, veuillez suivre le pack débutant.
        </p>
        <vs-button
          @click="goTo()"
          :style="{ width: '290px' }"
          :color="$store.state.aa_button_color"
          class="text-dark action_button mt-6"
          >Débuter la formation</vs-button
        >
      </div>
    </div>

    <div class="footer font-bold text-dark">
      <p>@2022 MTN Benin</p>
    </div>
  </div>
</template>

<script>
import auth from "../../../helpers/auth";

export default {
  name: "startBeginingPack",
  data() {
    return {
      contentCss: {
        background: null,
        backgroundSize: null,
        backgroundRepeat: null,
        backgroundAttachment: null,
        backgroundPosition: null,
      },
    };
  },
  computed: {
    navBarVLogoText() {
      return {
        "font-weight": "bold",
        "font-size": "14px",
        color: "#000000",
      };
    },
    appSettings() {
      return JSON.parse(localStorage.getItem("settings"));
    },
    activeUserInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    user_displayName() {
      return this.activeUserInfo.firstname + " " + this.activeUserInfo.lastname;
    },
  },
  methods: {
    logout() {
      if (this.$auth.profile) this.$auth.logOut();
      if (localStorage.getItem("accessToken")) {
        auth.logout();
        // this.$store.commit("UPDATE_USER_INFO", {}, { root: true });
        this.$router.push("/login").catch(() => {});
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change("admin");
      //localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push("/login").catch(() => {});
    },
    goTo() {
      let begining_pack_slug = this.$route.params.slug;
      this.$router.push({
        path: "/aa/formation/packs/" + begining_pack_slug + "/follow-pack",
      });
    },
  },
  mounted() {
    this.contentCss.background = `url(${require("@/assets/images/begining-pack/welcome.png")})`;
    this.contentCss.backgroundSize = `auto 100% !important`;
    this.contentCss.backgroundRepeat = `no-repeat`;
    this.contentCss.backgroundAttachment = `fixed`;
    this.contentCss.backgroundPosition = `right bottom`;
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.information-section {
  min-height: calc(100vh - 8.5rem);
  display: flex;
  align-items: center;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  padding: 15px;
}

.actions {
  margin-left: 24px;

  .welcome_title {
    font-size: 50px;
    line-height: 75px;
    color: #000000;
  }

  .welcome_message {
    font-size: 18px;
    line-height: 23px;
    color: #000000;
    .user_displayname {
      color: #ffcc00;
    }
  }
}

/* Clear floats after the columns */
.information-section:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
  }
}

/* Style the footer */
.footer {
  justify-content: space-between !important;
  flex-wrap: wrap !important;
  padding: 1rem 2.2rem;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
}

.logo-img {
  width: 5rem !important;
}

.profil_dropdown {
  // width: 170px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 25px;
  gap: 10px;
  height: 34px;
  background: #ffffff;
  border-radius: 50px;
  span {
    font-size: 14px;
    line-height: 16px;
  }
  box-shadow: 7px 7px 10px -2px rgba(0, 0, 0, 0.3);
}
</style>